import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useListUserGroupOrgBindings(groupId: string | undefined) {
  return useQuery({
    queryKey: ["user-groups", groupId, "org-bindings"],
    queryFn: () => api.listUserGroupOrgBindings(groupId!),
    enabled: !!groupId,
  });
}
